import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { TextField } from '../TextField/';
// TODO: improve
const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (_jsx(IMaskInput, { ...other, inputRef: ref, placeholderChar: '\u2000', mask: "aa00 #### #### #### #### #### #### #??? ??", definitions: { '#': /\w/, '?': /\w?/ }, prepare: (value) => value.toUpperCase().replace(/\s+$/g, ''), onAccept: (value) => onChange({
            target: {
                value: value.replace(/\s+/g, ''),
            },
        }), overwrite: true }));
});
export const IbanField = forwardRef(function IbanField({ InputProps, value, ...props }, ref) {
    return (_jsx(TextField, { ...props, ref: ref, value: value, InputProps: {
            ...(InputProps || {}),
            // FIXME: find a better solution for this type assertion
            inputComponent: TextMaskCustom,
        } }));
});
